<template>
    <div class="atlas-setting">
        <el-scrollbar style="height:100% ;overflow-x:hidden">
            <el-card style="margin: 0 0 50px 0;height: 100%;">
                <div>
                    <el-button style="" @click="goBack">返回</el-button>
                </div>
                <div>


                    <div style="height: 590px; width: 76%;position: relative;margin-left: 12%;">
                        <!-- <iframe id="myFrameId" name="ifrmName" :src="iframeUrl" width="100%" height="700px"></iframe> -->
                        <!-- <largeScreen1 style="height:100%;width: 100%;" /> -->
                        <atlasView :key="randomKey" style="height: 100%; width: 100%;" :shouyeBackdropImage="shouyeBackdropImage"
                            :shouyeIcon="tableData"></atlasView>

                    </div>
                </div>

                <div style="margin: 1% 0;" class="zhoumian">
                    <span>图片视频上传：</span>
                    <el-upload :show-file-list="true" v-loading="loading" :action="fileUrl" accept="image/jpeg,image/png,video/mp4,video/ogg,video/wmv" list-type="picture-card"
                        style="display: inline-block;"  :on-success="handleSuccess"
                        :before-upload="beforeUploadVideo" :before-remove="() => false" :file-list="shouyeBackdropImage"
                        :headers="{ Authorization: token }">
                        <i slot="default" class="el-icon-plus"></i>

                        <div slot="file" slot-scope="{file}" style="width: 148px;height: 148px;">

                            <img v-if="file.contentType=='image'" class="el-upload-list__item-thumbnail" :src=" file.url" alt="">
                            <video v-if="file.contentType=='video'"
                                v-bind:src=" file.url" 
                                controls="controls" style="width: 100%;height: 100%;">
                                您的浏览器不支持视频播放
                            </video>
                            <span class="el-upload-list__item-actions" >
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                    <i class="el-icon-download"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete"
                                    @click="handleRemove(file, shouyeBackdropImage)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                        <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent"
                            style="margin-top: 7px"></el-progress>

                    </el-upload>
                    <div style="color: red;margin-top: 3px;">注：只上传格式为 jpg / png 图片文件，或者MP4 /WebM / Ogg 视频文件</div>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogFile.url" alt="" v-if="dialogFile.contentType=='image'">
                        <video v-if="dialogFile.contentType=='video'"
                                v-bind:src="dialogFile.url" 
                                controls="controls" style="width: 100%;height: 100%;">
                                您的浏览器不支持视频播放
                            </video>
                    </el-dialog>

                    <!-- <el-upload class="avatar-uploader" :action="fileUrl" v-bind:on-progress="uploadVideoProcess"
                        v-bind:on-success="handleVideoSuccess" v-bind:before-upload="beforeUploadVideo"
                        v-bind:show-file-list="false" :headers="{ Authorization: token }">

                        <video v-if="videoForm.showVideoPath != '' && !videoFlag"
                            v-bind:src="urlprefix + videoForm.showVideoPath" class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i class="el-icon-plus avatar-uploader-icon"></i>

                        <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent"
                            style="margin-top: 7px"></el-progress>


                    </el-upload> -->
                </div>

            </el-card>

        </el-scrollbar>
    </div>
</template>
  
<script>

import * as api from "@/api/large-screen";
import * as user from "@/api/user";

import CFG from "@/config/config";

import largeScreen from "@/pages/large-screen/index.vue";
import largeScreen1 from "@/pages/large-screen/index-view.vue";
import atlasView from "@/pages/large-screen/components/atlas-view.vue";
import axios from 'axios'
import * as cloudScreenApi from "@/api/cloud-screen";
export default {
    name: "terminal-configuration",
    components: { largeScreen, largeScreen1, atlasView },
    data() {
        return {
            urlprefix: CFG.LOTIP,
            token: "Bearer" + " " + this.$store.state.token,
            dialogFile: '',
            dialogVisible: false,
            disabled: false,
            tableData: [],
            organization: {},
            temp: null,
            device: null,
            fileUrl: CFG.LOTIP + "/mediaCapital/uploadFile?url=atlas&systemSid="+this.$route.params.systemSid, //图片文件上传地址,
            shouyeBackdropImage: [],

            iframeUrl: '',
            iconDialogVisible: false,
            ruleForm: {},
            dataStatus: false,
            iconIndex: null,
            iconKey: Math.random(),

            device: null,



            videoFlag: false,
            //是否显示进度条
            videoUploadPercent: "",
            //进度条的进度，
            isShowUploadVideo: false,
            //显示上传按钮
            videoForm: {
                showVideoPath: "",  //回显的变量
            },
            loading:false,
            randomKey:Math.random()
        };
    },

    methods: {

        //上传前回调
        beforeUploadVideo(file) {
            console.log(file.type)
            var fileSize = file.size / 1024 / 1024 < 50;   //控制大小  修改50的值即可
            if (
                [
                    "video/mp4",
                    "video/ogg",
                    "video/wmv",
                    "image/jpeg",
                    "image/png"
                ].indexOf(file.type) == -1     //控制格式
            ) {
                layer.msg("请上传正确的图片或视频格式");
                return false;
            }
            if (!fileSize) {
                layer.msg("图片视频大小不能超过50MB");
                return false;
            }
            this.loading=true
            this.isShowUploadVideo = false;
        },
        //进度条
        uploadVideoProcess(event, file, fileList) {    //注意在data中添加对应的变量名
            console.log("aaa",file.percentage)
            this.videoFlag = true;
            this.videoUploadPercent = file.percentage.toFixed(0) * 1;
        },
        //上传成功回调
        handleVideoSuccess(res, file) {
            this.isShowUploadVideo = true;
            this.videoFlag = false;
            this.videoUploadPercent = 0;

            console.log(res);
            //后台上传数据
            if (res.resp_code == "10000") {
                this.videoForm.showVideoPath = res.data.url;    //上传成功后端返回视频地址 回显
            } else {
                this.$message.error("上传失败！");
            }
        },








        beforeAvatarUpload(file) {
            // const isJPG = ["image/jpg", "image/jpeg", "image/png"].includes(file.type);
            const isLt5M = file.size / 1024 / 1024 < 10;
            // if (!isJPG) {
            //   this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            // }
            if (!isLt5M) {
                this.$message.error("上传头像图片大小不能超过 5MB!");
            }
            this.loading=true
            return isLt5M;
        },


        //（文件上传成功时的钩子）
        handleSuccess(res, file, fileList) {
            this.loading=false
            console.log(res, file, fileList);
            if (res.resp_code == "10000") {
                this.randomKey=Math.random()
                let arr = JSON.parse(JSON.stringify(this.shouyeBackdropImage))
                arr.push(res.data)
                this.shouyeBackdropImage = arr

            
            }
        },



        goBack() {
            window.history.back();

        },

        handleRemove(file, shouyeBackdropImage) {
            console.log(file)

            this.shouyeBackdropImage = shouyeBackdropImage.filter((item) => {
                return item.uid !== file.uid;
            });
            
            api.deleteMediaCapital(file.id).then(res => {
                if (res.resp_code == "10000") {
                    this.randomKey=Math.random()
                }
            })




        },
        handlePictureCardPreview(file) {
            console.log(file)
            let obj={
                url:'',
                contentType:''
            }
            obj.url= file.url
            obj.contentType= file.contentType
            this.dialogFile = obj;
            this.dialogVisible = true;
        },
        // imgUrl为图片路径，fileName为文件名
        async handleDownload(file) {
            const imageUrl =  file.url
            let arr = imageUrl.split("/")
            let name = arr[arr.length - 1]
            const url = await this.getImgArrayBuffer(imageUrl)
            const objectUrl = URL.createObjectURL(url);
            var a = document.createElement("a"); // 生成一个a元素
            var event = new MouseEvent("click"); // 创建一个单击事件
            a.download = name || "photo"; // 设置图片名称
            a.href = objectUrl; // 将生成的URL设置为a.href属性
            a.dispatchEvent(event); // 触发a的单击事件

        },
        //获取文件blob
        getImgArrayBuffer(url) {
            let _this = this;
            return new Promise((resolve, reject) => {
                //通过请求获取文件blob格式
                let xmlhttp = new XMLHttpRequest();
                xmlhttp.open("GET", url, true);
                xmlhttp.responseType = "blob";
                xmlhttp.onload = function () {
                    if (this.status == 200) {
                        resolve(this.response);
                    } else {
                        reject(this.status);
                    }
                };
                xmlhttp.send();
            });
        },

        handleDownload1(file) {

            console.log(file);
        },
        getAtlas() {
            cloudScreenApi.getMediaCapitals(this.$route.params.systemSid).then(res => {
                if (res.resp_code == "10000") {
                    this.shouyeBackdropImage=res.data


                }
            });
        },



    },
    async mounted() {
        console.log(this.$route.params.id, "-----------")
        this.getAtlas()
    }
};
</script>
    
<style lang="scss" scoped>
/* 推荐，实现简单 */


.el-upload-list__item.is-ready,
.el-upload-list__item.is-uploading {
  display: none !important;
}
.avatar-uploader-icon {
    border: 1px dashed #d9d9d9 !important;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px !important;
    position: relative !important;
    overflow: hidden !important;
}

.avatar-uploader .el-upload:hover {
    border: 1px dashed #d9d9d9 !important;
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 300px;
    height: 178px;
    display: block;
}
</style>

<style>

.atlas-setting /deep/ .el-upload-list__item.is-ready,
.el-upload-list__item.is-uploading {
    display: none !important;
}

.atlas-setting /deep/ .el-loading-mask{
    border: 1px dashed #c0ccda;
}
</style>
    